import cx from 'classnames';
import './Avatar.css';

/**
 * QHS Avatar v2
 * -------------
 *   <Avatar size="md" initials="EB" />
 *   <Avatar size="lg" src="/path.jpg" alt="Elena Bychkova" />
 *   <Avatar size="md" initials="SJ" status="online" />
 */
const Avatar = ({
  size = 'md',
  initials,
  src,
  alt,
  status,
  className,
  ...rest
}) => {
  return (
    <span className={cx('qhs-avatar', `qhs-avatar--${size}`, className)} {...rest}>
      {src ? (
        <img src={src} alt={alt || ''} className="qhs-avatar__img" />
      ) : (
        <span className="qhs-avatar__initials">{(initials || '').slice(0, 2).toUpperCase()}</span>
      )}
      {status && <span className={cx('qhs-avatar__status', `qhs-avatar__status--${status}`)} aria-label={status} />}
    </span>
  );
};

export const AvatarGroup = ({ children, className, ...rest }) => (
  <span className={cx('qhs-avatar-group', className)} {...rest}>
    {children}
  </span>
);

export default Avatar;
